import type { Participant } from '@seen/core/models/patients/participant'
import { cn } from '@seen/ui'
import { compact } from 'lodash-es'

import type { JSX } from 'react'

interface PatientNameProps {
  participant: Participant
  // Overrides the rendered name; the nickname suffix stays the same.
  name?: string
  className?: string
  nicknameClassName?: string
}

export function PatientName({
  participant,
  name,
  className,
  nicknameClassName,
}: PatientNameProps): JSX.Element {
  const alternativeNames = compact([participant.nickname]).join(', ')
  return (
    <span className={className}>
      {name ?? participant.name}
      {alternativeNames && (
        <span className={cn('text-foreground-secondary', nicknameClassName)}>
          {' '}
          ({alternativeNames})
        </span>
      )}
    </span>
  )
}
